module.exports = __webpack_public_path__ + "static/img/google_btn.b3f07346.png";